import { errorRangoFechasFiltro } from "@/util/validarRangoFechasFiltro";
import { createAxios } from "./axiosHttpMarconi";
export const paradaService = { getParadasExcel,
  getParadas,
  getEnviosByParada,
  getEtiquetaPDFByParada,
  sendEmailEtiquetasByParada,
  anularParada,
  estadosParada,
  getImages,
  getJustificantePDFByParada,
  getParada,
  createRecogida,
  getEventosDisponibles,
  newEventoParada,
};

function getEventosDisponibles(tipo) {
  const axios = createAxios();
  const params = new URLSearchParams({ page: 0, limit: 2000, tipo, sort: "codigo", order: "ascending" });
  return axios.get(`/estados-parada?${params.toString()}`);
}

function newEventoParada(idParada, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  return axios.post(`/franquicia/${user.extraData.franquiciaId}/parada/${idParada}/estados`, body);
}

function getParada(paradaId) {
  const axios = createAxios();
  let urlPath = `/parada/${paradaId}`;
  return axios.get(urlPath);
}

function paramsParadas(filters = {}) {
  const params = new URLSearchParams({ vista: filters.vista || "" });
  if (filters.date && filters.date.length === 2) {
    params.set("fecha_inicio", filters.date[0]); params.set("fecha_fin", filters.date[1]);
  }
  ["idCliente", "numero", "referenciaCourier", "courier", "codigoPostal"].forEach((key) => {
    if (filters[key]) params.set(key, filters[key]);
  });
  if (filters.estados && filters.estados.length) params.set("estados", filters.estados.join());
  if (filters.conIncidencia === true) params.set("conIncidencia", "true");
  if (filters.sort) { params.set("sort", filters.sort.prop); params.set("order", filters.sort.order); }
  return params;
}

function getParadas(pagination, filters = {}) {
  const error = errorRangoFechasFiltro(filters, "date");
  if (error) return Promise.reject(error);
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const params = paramsParadas(filters);
  params.set("page", pagination ? pagination.currentPage - 1 : 0);
  params.set("limit", pagination ? pagination.perPage : 10);
  return axios.get(`/franquicia/${user.extraData.franquiciaId}/paradas?${params.toString()}`);
}

function getParadasExcel(filters = {}) {
  const error = errorRangoFechasFiltro(filters, "date");
  if (error) return Promise.reject(error);
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const params = paramsParadas(filters);
  return axios.get(`/franquicia/${user.extraData.franquiciaId}/paradas/excel?${params.toString()}`, { responseType: "blob" });
}

function getEnviosByParada(idParada, pagination) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/parada/${idParada}/envios`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=10";
  }
  return axios.get(urlPath);
}

function getEtiquetaPDFByParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/parada/${idParada}/etiqueta/download`;
  return axios.get(urlPath, { responseType: "blob" });
}

function sendEmailEtiquetasByParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/parada/${idParada}/etiqueta/mail`;
  return axios.get(urlPath);
}

function anularParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/parada/${idParada}/anular`;
  return axios.post(urlPath);
}

function estadosParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/parada/${idParada}/estados`;
  return axios.get(urlPath);
}

function getImages(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/parada/${id}/imagenes`;
  return axios.get(urlPath);
}
function getJustificantePDFByParada(idParada) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/parada/${idParada}/justificante`;
  return axios.get(urlPath, {
    responseType: "blob",
  });
}

function createRecogida(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/paradas/recogida`;
  return axios.post(urlPath, body);
}
